import script from "./YearBox.vue?vue&type=script&setup=true&lang=js"
export * from "./YearBox.vue?vue&type=script&setup=true&lang=js"

import "./YearBox.vue?vue&type=style&index=0&id=72688374&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72688374"]])

export default __exports__